import { Box } from '@mui/material';
import { Category } from 'enum/categories';
import React, { ReactElement } from 'react';
import { Image } from '../../lib/Image';

export const categoryIconMap: Required<Record<Category, string>> = {
  'Arts & Concerts': '/icons/filters/art-concert.svg',
  'Community Service': '/icons/filters/community-service.svg',
  Cultural: '/icons/filters/cultural.svg',
  'Health & Wellness': '/icons/filters/health-wellness.svg',
  'Lectures & Workshops': '/icons/filters/lectures-workshops.svg',
  Meetings: '/icons/filters/meetings.svg',
  'Parties & Socials': '/icons/filters/parties-socials.svg',
  Professional: '/icons/filters/professional.svg',
  'Sports & Fitness': '/icons/filters/sports.svg',
  All: '/icons/filters/all.svg',
};

export const categoryIconFilledMap: Required<Record<Category, string>> = {
  'Arts & Concerts': '/icons/filters/art-concert-filled.svg',
  'Community Service': '/icons/filters/community-service-filled.svg',
  Cultural: '/icons/filters/cultural-filled.svg',
  'Health & Wellness': '/icons/filters/health-wellness-filled.svg',
  'Lectures & Workshops': '/icons/filters/lectures-workshops-filled.svg',
  Meetings: '/icons/filters/meetings-filled.svg',
  'Parties & Socials': '/icons/filters/parties-socials-filled.svg',
  Professional: '/icons/filters/professional-filled.svg',
  'Sports & Fitness': '/icons/filters/sports-filled.svg',
  All: '/icons/filters/all-filled.svg',
};

export interface CategoryIconProps {
  category: Category;
  size?: number;
  selected?: boolean;
}

export const CategoryIcon = ({
  category,
  size = 40,
  selected = false,
}: CategoryIconProps): ReactElement => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
          transform: `scale(${size / 40})`,
        },
      }}
    >
      {selected ? (
        <Image alt={category} src={categoryIconFilledMap[category]} />
      ) : (
        <Image alt={category} src={categoryIconMap[category]} />
      )}
    </Box>
  );
};
